<template>
  <div>
    <memlist-modal ref="popup">
      <div class="native-progress-wrapper">
        <div
          class="native-progress-bar"
          :style="{ width: progressPercent + '%' }"
        >
          <span class="progress-label">
            Progress: <strong>{{ current_value.toFixed(2) }} / {{ max_value }}</strong>
          </span>
        </div>
      </div>
    </memlist-modal>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {
  name: 'GenericProgressPopup',
  mixins: [toasts],
  props: ['max_value', 'current_value'],
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'periods', 'companies']),
    progressPercent() {
      if (!this.max_value || this.max_value === 0) return 0;
      return Math.min(100, (this.current_value / this.max_value) * 100);
    }
  },
  methods: {
    show() {
      this.$refs['popup'].show();
    }
  }
};
</script>
<style scoped>
.native-progress-wrapper {
  height: 2rem;
  width: 100%;
  background-color: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.native-progress-bar {
  height: 100%;
  background-color: #3699ff;
  color: #fff;
  display: flex;
  align-items: center;
  padding: 0 10px;
  transition: width 0.3s ease;
  white-space: nowrap;
  font-size: 0.9rem;
}

.progress-label {
  z-index: 1;
}
</style>
